import React from 'react'
import { Navbar } from './ui/resizable-navbar'
import Footer from './section/footer'
import MobileNav from './ui/mobileNav'
import { Toaster } from 'sonner'
import Header from './ui/header'

interface LayoutProps {
   children: React.ReactNode
}

const Layout = ({ children }: LayoutProps) => {

   return (
      <>
         <Header />
         <main>
            {children}
         </main>
         {/* <Footer /> */}
         <Toaster position="bottom-right" richColors />
      </>
   )
}

export default Layout
